import { Box, Text } from 'braid-design-system';
import type { ComponentProps } from 'react';

type BoxProps = ComponentProps<typeof Box>;
type TextProps = ComponentProps<typeof Text>;

export const TableHeaderCell = ({
  align = 'left',
  children,
  dataTestId,
  paddingLeft = 'small',
  paddingRight = 'small',
}: {
  align?: TextProps['align'];
  children: React.ReactNode;
  dataTestId?: string;
  paddingLeft?: BoxProps['paddingLeft'];
  paddingRight?: BoxProps['paddingRight'];
}) => (
  <Box
    background="neutralLight"
    component="th"
    data-testid={dataTestId}
    paddingY="small"
    paddingLeft={paddingLeft}
    paddingRight={paddingRight}
    style={{
      whiteSpace: 'nowrap',
    }}
  >
    <Text size="small" align={align} weight="medium">
      {children}
    </Text>
  </Box>
);
